// eslint-disable-next-line no-unused-vars
import React from 'react';
// eslint-disable-next-line no-unused-vars
import { FxPageContainer } from 'axp-fx-common';
// eslint-disable-next-line no-unused-vars
import Actions from './Actions/Actions';

// TODO take care of error boundary ...
const MyActions = () => (
  <FxPageContainer>
    <Actions />
  </FxPageContainer>
);

export default MyActions;
